import { render, staticRenderFns } from "./history-page.vue?vue&type=template&id=da3ce434&scoped=true&"
import script from "./history-page.vue?vue&type=script&lang=ts&"
export * from "./history-page.vue?vue&type=script&lang=ts&"
import style0 from "./history-page.vue?vue&type=style&index=0&id=da3ce434&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3ce434",
  null
  
)

export default component.exports